module.exports = __webpack_public_path__ + "img/img2.047ee693.jpg";